import client from "../client";

// ===== Medicines =====

export const getMedicines = () => client.get("/get-all-medicines");

export const searchMedicines = (name) =>
  client.get("/search-medicines", { params: { name } });

export const createMedicine = (data) => client.post("/add-medicine", data);
export const updateMedicine = (id, data) => client.post(`/update-medicine/${id}`, data);
export const deleteMedicine = (id) => client.delete(`/delete-medicine/${id}`);

// ===== Branch-wise stock =====

export const getBranchStock = (params) =>
  client.get("/get-branch-stock", { params });

export const updateBranchStock = (data) =>
  client.post("/update-branch-stock", data);

export const getAllBranchesStock = () =>
  client.get("/get-all-branches-stock");

export const initBranchStock = (branchId) =>
  client.post("/init-branch-stock", { branchId });

// ===== Treatments =====
export const getTreatments = () => client.get("/get-all-services");
export const searchTreatments = (name) =>
  client.get("/search-services", { params: { name } });
export const createTreatment = (data) => client.post("/add-service", data);
export const updateTreatment = (id, data) => client.post(`/edit-service/${id}`, data);
export const deleteTreatment = (id) => client.delete(`/delete-service/${id}`);

// ===== User Registration Requests =====
export const getPendingRequests = () => client.get("/admin/pending-users");
export const getAllUsersByStatus = (params) => {
  const { status = "all", page = 1, limit = 10 } = params || {};
  return client.get("/admin/all-users-by-status", { params: { status, page, limit } });
};
export const searchUsersByStatus = (params) => {
  const { search, status = "all", page = 1, limit = 10 } = params || {};
  return client.get("/admin/all-users-by-status", { params: { search, status, page, limit } });
};
export const approveRequest = (id) => client.put(`/admin/approve-user/${id}`);
export const rejectRequest = (id) => client.delete(`/admin/reject-user/${id}`);
export const rejectApprovedUser = (id) => client.put(`/admin/reject-approved-user/${id}`);
export const searchRequests = (query) =>
  client.get("admin/pending-users", { params: { query } });
